<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-4 col-lg-3">
        <ul class="list-group mb-xs-24 mb-sm-24">
          <li
            v-for="category in categories"
            :key="category.slug"
            :class="[
              'list-group-item categories-menu-item',
              { active: isActiveCategory(category.slug) }
            ]"
            @click="changeActiveCategory(category)"
          >
            {{ category.name }}
          </li>
        </ul>
      </div>

      <div class="col-12 col-md-8 col-lg-8 offset-lg-1">
        <h3 class="mb-xs-24 mb-sm-24 mb-lg-32">
          {{ activeCategory.name }}
        </h3>

        <div
          v-for="faq in activeCategory.faq"
          :key="faq.slug"
          :ref="faq.slug === activeQuestion ? 'activeFaq' : 'faq'"
          class="expansion-panel--help"
          itemscope
          itemprop="mainEntity"
          itemtype="https://schema.org/Question"
        >
          <ExpansionPanel
            :on-toggle="() => toggleAnswer(faq)"
            :expanded="faq.slug === activeQuestion"
          >
            <template #title>
              <div itemprop="name">
                {{ faq.question }}
              </div>
            </template>
            <template #body>
              <div
                itemscope
                itemprop="acceptedAnswer"
                itemtype="https://schema.org/Answer"
              >
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div itemprop="text" v-html="faq.answer" />
              </div>
            </template>
          </ExpansionPanel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExpansionPanel from '~/components/ExpansionPanel'
import { scrollIntoView } from '~/utils/index'

export default {
  components: {
    ExpansionPanel
  },
  props: {
    categories: {
      type: Array,
      required: true
    },
    activeCategory: {
      type: Object,
      required: true
    },
    activeQuestion: {
      type: String,
      default: ''
    },
    changeActiveCategory: {
      type: Function,
      default: () => {}
    }
  },
  mounted() {
    const activeFaq = this.$refs.activeFaq && this.$refs.activeFaq[0]

    if (activeFaq && window.scrollY === 0) {
      scrollIntoView(activeFaq, { behavior: 'smooth' })
    }
  },
  methods: {
    isActiveCategory(slug) {
      return slug === this.activeCategory.slug
    },
    toggleAnswer(faq) {
      const { question } = this.$route.query
      const { slug } = faq

      if (question !== slug) {
        this.$router.push({
          path: this.$route.path,
          query: { question: slug }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list-group {
  border-radius: 5px;
  height: auto;
  position: sticky;
  top: 18px;
}

.categories-menu-item {
  border: solid 2px $grey-02;
  border-bottom: 0;
  box-sizing: border-box;
  display: inline-block;
  font-weight: $font-weight-semibold;
  height: 60px;
  padding: 18px 0 18px 18px;
  width: 100%;

  &.active {
    background: $black;
    border: solid 2px $black;
    color: $white;

    &:last-child {
      border-bottom: solid 2px $black;
    }

    &:hover {
      background: $black;
    }
  }

  &:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  &:last-child {
    border-bottom: solid 2px $grey-02;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  &:hover {
    background: $grey-02;
    cursor: pointer;
  }
}

.expansion-panel--help {
  font-size: 18px;
}
</style>
